export const getReplicachePokeWebSocketChannelName = (spaceId: string) =>
	`replicache-poke?space=${spaceId}`;

export const REPLICACHE_POKE_WEB_SOCKET_MESSAGE = "poke";
